/** Bordas mais visíveis na área do anunciante (tabelas, cards, divisores, campos). */
export const advertiserLayoutSx = {
    '& .MuiCard-root': {
        border: '1px solid',
        borderColor: 'grey.400',
        boxShadow: 'none',
    },
    '& .MuiTable-root': {
        border: '1px solid',
        borderColor: 'grey.400',
        borderRadius: 1,
        borderCollapse: 'separate',
    },
    '& .MuiTableCell-root': {
        borderBottom: '1px solid',
        borderColor: 'grey.300',
    },
    '& .MuiTableHead-root .MuiTableCell-root': {
        borderBottomWidth: 2,
        borderBottomColor: 'grey.400',
        backgroundColor: 'grey.50',
    },
    '& .MuiTableBody-root .MuiTableRow:last-child .MuiTableCell-root': {
        borderBottom: 'none',
    },
    '& .MuiDivider-root': {
        borderColor: 'grey.400',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'grey.400',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'grey.600',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
    },
};
